import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const tableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLW100005_01,
  },
  {
    title: "システム利用者ID",
    keyword: "userId",
    type: "text",
  },
  {
    title: "氏名",
    keyword: "name",
    type: "text",
  },
  {
    title: "パスワード",
    keyword: "password",
    typeForLabelText: "password",
    requiredIcon: true,
    inputProps: { maxLength: 100 },
  },
  {
    title: "パスワード（確認）",
    keyword: "passwordConfirm",
    typeForLabelText: "password",
    requiredIcon: true,
    inputProps: { maxLength: 100 },
  },
];

const schema = {
  password: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[!-~]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0056E"),
    },
    minLength: {
      value: 6,
      message: TkPropertyMessageGet("TKMSG_SCR0045E", "6"),
    },
    maxLength: {
      value: 100,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "100"),
    },
  },
  passwordConfirm: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[!-~]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0056E"),
    },
    minLength: {
      value: 6,
      message: TkPropertyMessageGet("TKMSG_SCR0045E", "6"),
    },
    maxLength: {
      value: 100,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "100"),
    },
    validate: (value: any, formValues: any) => {
      if (formValues.password !== formValues.passwordConfirm) {
        return TkPropertyMessageGet("TKMSG_SCR0078E");
      }
    },
  },
};

export { tableList, schema };
